import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function EmployeePayrollModalCard({
  index,
  date,
  item,
  ExpenseItemssArr,
  setExpenseItemssArr,
  paymentMode,
}) {
  console.log("item ", item);
  return (
    <Card
      sx={{
        mt: 1,
        // mr: 2,
        border: "1.5px solid #01008B",
        bgcolor: "#EEEEFF",
        cursor: "pointer",
        boxShadow: 3,
        height: "30px",
        // ":hover": {
        //   bgcolor: "#2892ba17",
        // },
      }}
      onClick={() => {}}
    >
      <CardContent sx={{ p: 0, height: "100%", ml: 1 }}>
        <Grid container alignItems="center" sx={{ height: "100%", px: 1 }}>
          {/* <Grid>{index + 1}</Grid> */}
          <Grid xs={1} sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // fontWeight: 600,
              }}
            >
              {item?.billNumber}
            </Typography>
          </Grid>
          <Grid xs={4} sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                overflow: "Hidden",
                textOverflow: "ellipsis",
                fontWeight: "600",
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                // fontWeight: 600,
              }}
            >
              {date}
            </Typography>
          </Grid>
          <Grid xs={4} sx={{ display: "flex" }}>
            <Typography
              sx={{
                // overflow: "Hidden",
                // textOverflow: "ellipsis",
                display: "-webkit-box",
                fontWeight: "400",
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
                whiteSpace: "normal",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                // fontWeight: 600,
                // color: "blac",
              }}
            >
              {paymentMode}
            </Typography>
          </Grid>
          <Grid xs={2} sx={{ display: "flex", alignItems: "center" }}>
            <CurrencyRupeeIcon
              sx={{ fontWeight: "600",fontSize: { xs: "12px", sm: "13px", md: "15px" }, color: "#01008B" }}
            />

            <Typography
              sx={{
                // overflow: "Hidden",
                // textOverflow: "ellipsis",
                display: "-webkit-box",
                fontWeight: "600",
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
                color: "#01008B",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                // fontWeight: 600,
              }}
            >
              {item?.counterSalesChild
                ?.reduce(
                  (sum, child) => sum + (child?.amountWithPayPercentage || 0),
                  0
                )
                ?.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
